<template>
    <div class="py-12 md:py-20">
        <div class="flex flex-col items-start gap-4 text-white">
            <h1 class="text-4xl font-semibold md:text-5xl">
                What do you need help with?
            </h1>

            <HelpCenterSearchForm />
        </div>
    </div>
</template>

<script setup lang="ts">
    import HelpCenterSearchForm from '@/HelpCenter/Component/HelpCenterSearchForm.vue'
</script>
